import { useCallback } from 'react';
import { useTreeReferencesGlobalContext } from '../../../../tree/references/TreeReferencesGlobalContext.tsx';
import { type Maybe } from '../../../../utils/typings.ts';
import { PlaceholderParameterFallbackInput } from './PlaceholderParameterFallbackInput.tsx';
import { type PlaceholderParameter } from './types.ts';

interface Props {
  parameter: PlaceholderParameter;
  onChange?: (value: Maybe<string>) => void;
}

export function PlaceholderParameterInput(props: Props) {
  const { parameter, onChange } = props;
  const globalContext = useTreeReferencesGlobalContext();
  const placeholderParameterInputRenderer =
    globalContext?.placeholderParameterInputRenderer;

  const handleChange = useCallback(
    (value: Maybe<string>) => {
      onChange?.(value);
    },
    [onChange],
  );

  if (placeholderParameterInputRenderer) {
    return placeholderParameterInputRenderer(parameter, handleChange);
  }

  return <PlaceholderParameterFallbackInput parameter={parameter} />;
}
